<template>
  <div>
    <Header :title="'创建工单'"/>
    <van-panel>
       <div slot="header" class="heder">
         <div class="header-wraper">
           <div class="left-part">
             <div>单位名称{{infos.enterprise_name}}</div>
             <div class="projects">
                <span>项目名称:{{infos.name}}</span>
                <span>项目状态:{{infos.status}}</span>
             </div>
           </div>
         </div>
        </div>
       <div slot="footer" class="ques">
          <div class="ques-title">
             <span>问题：</span>
             <van-field
              v-model="title"
              autosize
              maxlength="20"
              placeholder="请输入问题标题"
            />
          </div>
          <div class="fix-methods">
            <van-field
              ref="textarea"
              v-model="message"
              rows="3"
              autosize
              type="textarea"
              show-word-limit
              maxlength="500"
              placeholder="请尽量详细的描述问题，以便我们为您提供更好的帮助；如果是连锁企业门店问题，请填写出问题的门店名称"
            />
            </div>
        </div>
       <div slot="footer" class="ques-detal">
          <div class="ques-title">
            截图 ：({{fileList.length}}/5)
          </div>
          <div class="fix-methods">
            <van-uploader  v-model="fileList" :multiple="true" max-count="5" :preview-full-image="false" :before-read="beforeRead" />
            <div class="upLoad">
                <label for="pop_video" id="labelr">
                <van-loading size="24px" vertical class="jiazaizhong" v-if="isloading">上传中...</van-loading>
                <video id="videoId" controls width="100%"></video>
                <input style="display:none;" id="pop_video" type="file" accept="video/*" capture="camcorder" v-on:change="getVideo($event, '2')" name="fileTrans" ref="file" value="">
                <div class="inputVideo">上传视频</div>
                </label>
              </div>
            </div>
          </div>
         
    </van-panel>
    <van-field
      readonly
      clickable
      name="picker"
      :value="value"
      class="types"
      label="问题类型"
      placeholder="请选择问题类型"
      @click="showPicker = true"
    />
    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-field
      readonly
      clickable
      name="picker"
      :value="value1"
      class="types"
      label="紧急程度"
      placeholder="请选择紧急程度"
      @click="showPicker1 = true"
    />
    <van-popup v-model="showPicker1" position="bottom">
      <van-picker
        show-toolbar
        :columns="columns1"
        @confirm="onConfirm1"
        @cancel="showPicker1 = false"
      />
    </van-popup>
    <van-row type="flex" justify="center">
      <van-col span="1"></van-col>
      <van-col span="22">
        <van-field v-model="form.tel" placeholder="请输入可以联系到您的电话/手机号" label="联系电话" type="digit"/>
      </van-col>
      <van-col span="1"></van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="1"></van-col>
      <van-col span="22">
        <van-field style="color:#323233" v-model="form.stat" readonly label="工单类型"/>
      </van-col>
      <van-col span="1"></van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="1"></van-col>
      <van-col span="22">
         <van-field v-model="form.qq" placeholder="请输入可以联系到您的QQ" label="QQ联系方式" type="digit"/>
      </van-col>
      <van-col span="1"></van-col>
    </van-row>
    <van-row type="flex" justify="center">
      <van-col span="1"></van-col>
      <van-col span="22">
        <van-field v-model="form.remoteMode" placeholder="请输入远程账号(选填)" label="远程账号"/>
      </van-col>
      <van-col span="1"></van-col>
    </van-row>
    <div class="logo-containers">
      <van-row type="flex" justify="center">
        <van-col span="6"></van-col>
        <van-col span="12"><van-button color="#004099" type="primary" @click="submit" block>提交</van-button></van-col>
        <van-col span="6"></van-col>
      </van-row>
    </div>
  </div>
</template>

<script>
import {Col, Row,Panel,Notify,Field,Uploader,CellGroup,Button,Toast} from 'vant';
import { Picker,Popup,Loading } from 'vant';

import Header from '../../components/backheader.vue'
import { mapState } from 'vuex'
// var url = window.g.uploadUrl
  export default {
    computed: {
      ...mapState({
      'userinfo': state=>state.user.userinfo
      })
    },
    created() {
      this.getRemoteMode()
    },
    mounted(){
      // Notify({ type: 'danger', message: '通知内容' });
      this.getDJBH()
      this.findInfo()
      this.findStatus("kf_order_type")
      this.findStatus("kf_order_priority")
      this.form.tel = this.userinfo.phonenumber
      let str = this.stateType(this.$route.query.stat) 
      this.form.stat = str
      
      // this.changestatus()
    },
    beforeRouteEnter:(to,from,next)=>{
      if(from.name == "FeedBack"){
        next()
      }else{
        next({path:'/feedback',replace:true})
      }
    },
    components : {
      Header,
      [Panel.name]:Panel,
      [Toast.name]:Toast,
      [Notify.name]:Notify,
      [Field.name]:Field,
      [CellGroup.name]:CellGroup,
      [Button.name]:Button,
      [Col.name]:Col,
      [Row.name]:Row,
      [Loading.name]:Loading,
      [Uploader.name]:Uploader,
      [Picker.name]:Picker,
      [Popup.name]:Popup 
    },
    data(){
      return {
        message : '',
        DJBH : '',
        videoURL:"",
        title:"",
        orderTypeList:[],
        priorityList:[],
        isloading:false,
        infos:{},
        value: '问题',
        value1:"一般",
        columns: ['问题','需求'],
        showPicker1:false,
        columns1:['立即处理','紧急','一般'],
        showPicker: false,
        fileList: [
            // Uploader 根据文件后缀来判断是否为图片文件
            // 如果图片 URL 中不包含类型信息，可以添加 isImage 标记来声明
          ],
        form : {
          tel : '',
          qq : '',
          stat:''
          }
        }
    },

    methods : {
      async getDJBH(){
         const res = await this.$http.post(`/m/kf/djbh`).then((data)=> data.data)
         this.DJBH = res.data
      },
      // this.form.remoteMode
      async getRemoteMode(){
         const res = await this.$http.get(`/mobile/lastRemote`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
          if(res.code==200){
            // console.log(res)
            if (res.data.lastRemote != '' && res.data.lastRemote != null) {
              this.form.remoteMode = res.data.lastRemote
              console.log(this.form.remoteMode)
            }
          }
      },
      onConfirm1(value){
        this.value1 = value;
        this.showPicker1 = false;
      },
      onConfirm(value) {
        this.value = value;
        this.showPicker = false;
      },
      async findStatus(dictType){
         const res = await this.$http.get(`/system/dict/data/type/${dictType}`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
          if(res.code==200){
            if(dictType=='kf_order_type'){
              this.orderTypeList = res.data
            }
            if(dictType=='kf_order_priority'){
              this.priorityList = res.data
            }
          }
      },
      stateType (i) {
        switch (i) {
          case '0': return '售中'
            break;
          case '1': return '售后'
            break;
        }
      },
      beforeRead(file){
        if (file.type != 'image/jpeg' && file.type != 'image/png') {
          Toast('请上传 jpg或png 格式图片');
          return false;
        }
        var size = file.size / 1024 /1024
        if(size>=20){
           Toast('图片必须小于20M');
           return;
        }
        let mf = new FormData();
        var _this = this;
        //将图片文件放入mf
        mf.append('orderImg', file);
        this.$http.post(`/business/workOrder/orderImg`,mf,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then(res => {
            if(res.data.code==200){
                _this.fileList.push({url: window.g.uploadUrl+res.data.imgUrl})
                Toast("上传成功")
            }else{
                Toast(res.data.msg)
            }
        })
      },
      changestatus(){
        this.$refs.textarea.$el.style.padding="0"
      },
      getFileURL (file) {
        let getUrl = null
        if (window.createObjectURL != undefined) {
        //basic
        getUrl = window.createObjectURL(file)
        } else if (window.URL != undefined) {//window.URL 标准定义
        //mozilla(firefox)
        //获取一个http格式的url路径，这个时候就可以设置<img>中的显示
        getUrl = window.URL.createObjectURL(file)
        } else if (window.webkitURL != undefined) {//window.webkitURL是webkit的内核
        //webkit or chrome
        getUrl = window.webkitURL.createObjectURL(file)
        }
        return getUrl 
    
      },
      getVideo (ev, typer) {
          //获取上传文件标签
          let filesId = document.getElementById('pop_video');
          //获取音频标签
          let videoId = document.getElementById('videoId')
          //把当前files[0]传给getFileURL方法， getFileURL方法对其做一处理
          let url = this.getFileURL(filesId.files[0])
          var isLt2M = filesId.files[0].size / 1024 / 1024 < 100;
          if (!isLt2M) {
             Toast('上传视频大小不能超过 100MB!');
             return;
          }
          var _this = this
          let formData = new FormData();
          this.isloading=true
          formData.append("orderVideo", filesId.files[0]);
          this.$http.post(`/business/workOrder/orderVideo`,formData,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then(res => {
            console.log(res.data.code)
              if(res.data.code==200){
                   Toast("上传成功")
                   videoId.src = window.g.uploadUrl+res.data.videoUrl
                   _this.videoURL = res.data.videoUrl
                   _this.isloading=false
              }else{
                _this.isloading=false
                Toast(res.data.msg)
              }
          })
     },
     async findInfo(){
       var id = this.$route.params.ques
       const res = await this.$http.get(`/mobile/order/projectInfo/${id}`,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
       if(res.code==200){
         this.infos = res.data
       }
     },
      async submit(){
        if(!this.message || !this.form.tel || !this.title || !this.value1){
           Toast( '请填写完整信息');
          return
        }

        const toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true,
          message: '上传中...',
        });
        var _this = this
        var params = {
          orderDesc : this.message,
          egistererTel : this.form.tel,
          otherContact : this.form.qq,
          orderTitle : this.title,
          registererProject:this.$route.params.ques,
          supportStatus:this.$route.query.stat
        }
      
        if(this.fileList!=""){
            var imgs = ""
            this.fileList.forEach(function(item){
                imgs+=item.url.replace(window.g.uploadUrl,'')+","
            })
           
            params.img = imgs.substring(0,imgs.length-1)
        }
        if(this.videoURL!=""){
            params.vedio = this.videoURL
        }
        if(this.value==""){
          Toast('请选择问题类型');
          return
        }
        var nowtype = ""
        this.orderTypeList.forEach(function(res){
          if(_this.value==res.dictLabel){
            nowtype = res.dictValue
          }
        })
        params.orderType = nowtype
        var nowpriority = ""
        this.priorityList.forEach(function(res){
          if(_this.value1==res.dictLabel){
            nowpriority = res.dictValue
          }
        })
     
        params.priority = nowpriority
        params.remoteMode = this.form.remoteMode
        const res = await this.$http.post(`/mobile/order/commit`,params,{headers: { Authorization: "Bearer " + this.$cookies.get('token')}}).then((data)=> data.data)
        if(res.code == 500){
          Toast(res.message);
          toast.clear();
        }else{
            toast.clear();
            this.$router.push({
            path : '/submitsucess'
          })
        }

      }
    }
  }
</script>

<style scoped>
.header-wraper{
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    box-sizing: border-box;
    width: 100%;
    padding: 10px 16px;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
}
.left-part{
  width: 286px;
  flex: 0 0 auto;
}
.right-part{
  position: relative;
  overflow: hidden;
  text-align: right;
  vertical-align: middle;
  word-wrap: break-word;
}
.type-color-ntpro{
  color : #00b949;
}
.type-color-onpro{
  color : #ff8300;
}
.type-color-donepro{
  color : #ff0000;
}
.ques-title{
  font-family: PingFangSC;
  font-weight: 500;
  font-size: 14px;
  color: rgb(16, 16, 16);
  font-style: normal;
  letter-spacing: 0px;
  line-height: 20px;
  text-decoration: none;
}
.fix-methods{
  padding-top : 10px;
  font-family: PingFangSC;
  font-weight: 400;
  font-size: 14px;
  color: rgb(16, 16, 16);
  word-wrap:break-word;
  display: flex;
  width: 100%;
}
.ques{
  margin-bottom : 20px;
}
.ques-img{
  margin-top : 20px;
}
.ques-img img{
  width : 100%;
  margin-bottom : 10px;
}
.projects span:first-child{
  margin-right: 3%;
}
.info-area{
    width: 100%;
    overflow: hidden;
    color: #323233;
    font-size: 14px;
    line-height: 24px;
    background-color: #fff;
}
.logo-containers{
  padding-bottom : 60px;
  text-align : center;
  height : 105px;
  margin-top : 60px;
}

.upLoad {
 background-color:#fff;
 /* height: 1.5rem; */
 text-align: left;
 padding: 0.3rem;
 width: 90px;
 float: left;
 margin-top:-5px;
}
 
#inspect .inputVideo {
 background-color: #00cc66;
 color: #fff;
 font-size: 0.32rem;
 width: 30%;
 height: 0.8rem;
 line-height: 0.8rem;
 border-radius: 0.4rem;
 text-align: center;
 margin: 0 auto; 
}
 
.inputVideo{
  text-align: center;
  color: #333;
  font-size: 13px;
  padding-top:82px;
  width:80px;
  text-align: center;
  position: relative;
  margin-top:-80px;
}

#videoId{
  width: 80px;
  height: 80px;
}
.ques-title span{
  float: left;
  display: block;
  margin-right: 2%;
}
.ques-title div{
  width:80%;
  float: left;
  padding:0;
  margin: 0;
}
/deep/ .van-panel__footer{
  margin-left:-10px;
   border-top:8px solid #f5f5f5;
}
.ques,.ques-detal{
  width:97%;
  margin: auto;
  padding-top:2%;
}
.ques-detal{
  border-top: 1px solid #eee;
  margin-top:2%;
  padding-top:4%;
}
/deep/ .van-cell{
  padding:10px 0px 0 0;
  margin:2% 0 0 0;
}
.types{
  width: 92%;
  margin: 5px auto 0;
}
/deep/ .van-cell::after{
  border:0;
}
.fix-methods /deep/ .van-cell{
  padding: 0;
  margin: 0;
}
.jiazaizhong{
    position: absolute;
    z-index: 2;
    margin: 0%;
    width: 80px;
    height: 80px;
    background: #f7f8fa;
}
/deep/ .van-loading__spinner{
  margin-top:14px;
}
</style>



// WEBPACK FOOTER //
// src/pages/createsheet/index.vue